import { createTheme } from "@mui/material";
import { tokens } from "./Tokens";

export const muiSwitchStyle = createTheme({
  components: {
    MuiSwitch: {
      variants: [
        {
          props: { size: "small" },
          style: {
            width: 44,
            height: 22,
            padding: 0,
            borderRadius: "50px",
            "&:active": {
              "& .MuiSwitch-thumb": {
                width: 15
              }
            },
            "& .MuiSwitch-switchBase": {
              paddingRight: "5px",
              "&.Mui-checked": {
                transform: "translateX(12px)",
                color: tokens.Text.General.Inverse,
                width: "100%",
                "& + .MuiSwitch-track": {
                  opacity: 1
                }
              }
            },
            "& .MuiSwitch-thumb": {
              width: 14,
              height: 14,
              transition: "0.5s"
            },
            "& .MuiSwitch-track": {
              color: tokens.Text.General.Inverse
            }
          }
        },
        {
          props: { size: "medium" },
          style: {
            width: 68,
            height: 34,
            padding: 0,
            borderRadius: "50px",
            "&:active": {
              "& .MuiSwitch-thumb": {
                width: 24
              }
            },
            "& .MuiSwitch-switchBase": {
              "&.Mui-checked": {
                color: tokens.Text.General.Inverse,
                width: "100%",
                "& + .MuiSwitch-track": {
                  opacity: 1
                }
              }
            },
            "& .MuiSwitch-thumb": {
              width: 24,
              height: 24,
              borderRadius: "50%",
              transition: "0.5s",
              margin: "-4px"
            },
            "& .MuiSwitch-track": {
              color: tokens.Text.General.Inverse
            }
          }
        }
      ]
    }
  }
});
